<template>
  <div
    :id="config.id"
    class="magic-ui-tabs"
    :style="style"
  >
    <magic-ui-container
      v-if="tabNav"
      class="magic-ui-tab-nav"
      :config="tabNav"
    >
      <div
        v-for="(tab, index) in tabItems"
        :key="index"
        class="magic-ui-tab-item"
        :style="tabStyle[index]"
        @click="active = index"
        @mouseover="()=>{ mouseover(index) }"
        @mouseout="mouseout"
      />
    </magic-ui-container>
    <div
      v-if="inMagic"
      class="magic-ui-tab-nav-bg"
      :style="`height: ${navHeight / 100}rem; line-height: ${navHeight / 100}rem;`"
    >
      点击浅蓝区域，选中标签页
    </div>

    <div
      v-if="!tabNav"
      class="magic-ui-tab-nav"
      :style="{width: `${navWidth / 100}rem`}"
    >
      <div
        v-for="(tab, index) in tabItems"
        :key="index"
        class="magic-ui-tab-item"
        :style="tabStyle[index]"
        @click="active = index"
        @mouseover="()=>{ mouseover(index) }"
        @mouseout="mouseout"
      />
    </div>
    <template v-if="config.isPreloadTab">
      <template v-for="(tab, index) in tabItems">
        <magic-ui-container
          :key="index"
          :class="`magic-ui-tab-panel ${index === active ? '' : 'magic-ui-tab-panel-hidden'}`"
          :config="tab"
          :style="`height: ${concentHeight / 100}rem`"
        />
      </template>
    </template>
    <template v-if="!config.isPreloadTab">
      <template v-for="(tab, index) in tabItems">
        <magic-ui-container
          v-if="index === active"
          :key="index"
          class="magic-ui-tab-panel"
          :config="tab"
          :style="`height: ${concentHeight / 100}rem`"
        />
      </template>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { transformStyle } from '@tencent/magic-ui-util';
import { preload } from './preload';
export default {
  name: 'MagicUiTabs',

  inject: {
    app: {
      default: {},
    },
  },

  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },

    model: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
  },

  data() {
    const isActiveTabExist = this.config.items?.filter(item => item.type !== 'tab-nav')[this.config.activeIndex];
    return {
      active: isActiveTabExist ? this.config.activeIndex : 0,
      hoverIndex: -1,
    };
  },

  computed: {
    tabNav() {
      return this.config.items?.find(item => item.type === 'tab-nav');
    },
    tabItems() {
      return this.config.items?.filter(item => item.type !== 'tab-nav') || [];
    },
    style() {
      if (!this.config) {
        return '';
      }

      let style = this.config.style || {};

      if (typeof style === 'function') {
        style = style.bind(this)(this, { model: this.model });
      } else {
        const base = ['Hippy-TV', 'TV'].includes(this.app.pageConfig.pageType) ? 1920 : 375;
        style = transformStyle(style, Vue, this.hippy, base);
      }
      style.paddingTop = `${this.tabNav ? this.navHeight / 100 : 0}rem`;

      return style;
    },

    tabStyle() {
      return this.tabItems.map((tab, index) => {
        let style = tab.tabTitle.style || {};
        let disabledStyle = tab.tabTitle.disabledStyle || {};

        if (typeof style === 'function') {
          style = style.bind(this)(this, { model: this.model });
        } else {
          const base = ['Hippy-TV', 'TV'].includes(this.app.pageConfig.pageType) ? 1920 : 375;
          style = transformStyle(style, Vue, this.inHippy, base);
        }

        if (index !== this.active && index !== this.hoverIndex && disabledStyle) {
          if (typeof disabledStyle === 'function') {
            disabledStyle = disabledStyle.bind(this)(this, { model: this.model });
          } else {
            const base = ['Hippy-TV', 'TV'].includes(this.app.pageConfig.pageType) ? 1920 : 375;
            disabledStyle = transformStyle(disabledStyle, Vue, this.inHippy, base);
          }

          style = Object.assign(style, disabledStyle);
        }

        return style;
      });
    },

    navWidth() {
      const tabPanes = this.tabItems;
      return tabPanes.reduce((acc, item) => +item.tabTitle.style.width + acc, 0);
    },
    navHeight() {
      const height = parseInt(this.tabNav?.style.height, 10) || 0;
      if (height > 0) {
        return height;
      }
      return Math.max(...this.tabItems.map(item => item.tabTitle.style.height));
    },
    concentHeight() {
      return parseInt(this.config.style.height, 10) - this.navHeight;
    },
  },
  watch: {
    active(newVal) {
      window.localStorage.setItem(this.getCacheIndexLsKey(), newVal);
    },
  },

  created() {
    if (this.config && this.config.id) {
      this.app.addContainer(this);
    }

    if (!this.config.created) {
      this.initialized = true;
    } else {
      typeof this.config.created === 'function' && this.config.created.call(this, this, this.app).then(() => {
        this.initialized = true;
      });
    }
  },

  beforeMount() {
    typeof this.config.beforeMount === 'function' && this.config.beforeMount.call(this, this, this.app);
  },

  mounted() {
    typeof this.config.mounted === 'function' && this.config.mounted.call(this, this, this.app);

    if (this.config.isPreloadTab) {
      window.setTimeout(() => {
        preload(this.config);
      }, 0);
    }
  },

  async destroyed() {
    if (this.config && this.config.id) {
      this.app.removeContainer(this);
    }

    if (typeof this.config.destroyed === 'function') {
      await this.config.destroyed();
    }
  },

  methods: {
    getCacheIndexLsKey() {
      // 暂时没有从cookie取用户唯一标识


      return `activeTab_${window?.magicUiconfig?.[0]?.actId}`;
    },
    getDefaultActiveTabIndex() {
      if (this.config.isSaveActiveIndexToLocal) {
        return Number(window.localStorage.getItem(this.getCacheIndexLsKey())) || this.config.activeIndex;
      }
      return this.config.activeIndex;
    },
    setActive(id) {
      this.active = this.tabItems.findIndex(item => item.id === id);
    },
    mouseover(index) {
      this.hoverIndex = index;
    },
    mouseout() {
      this.hoverIndex = -1;
    },
  },

};
</script>

<style lang="scss">
.magic-ui-tab-panel-hidden {
  height: 0 !important;
  width: 0 !important;
  visibility: hidden;
  transform: scale(0);
  opacity: 0;
  pointer-events: none;
}
.magic-ui-tabs {
  display: relative;
  .magic-ui-tab-nav {
    display: flex;
    overflow-x: auto;
    align-items: flex-end;

    .magic-ui-tab-item {
      cursor: pointer;
    }
  }

  .magic-ui-tab-nav-bg {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1000;
    text-align: center;
    background: rgba(51, 153, 255, 0.5);
  }
}
</style>
